import React from 'react';
import {useIntl} from 'react-intl';
import {NUMBER_TYPE} from '../util/BudgetUtils';
import {createFragmentContainer, graphql} from 'react-relay';
import {HighLevelNumber} from '../HighLevelNumber';
import {
	TableWrapper,
	TableSectionWrapper,
	TableSectionTitle,
	TableSectionTitleHeadline,
} from '../money/work_and_expenses/TableSection.styled';
import {HighLevelBudgetNumbersBox} from '../HighLevelBudgetNumbers.styled';
import ForecastTooltip from '../../../../../forecast-app/shared/components/tooltips/ForecastTooltip';
import {ForecastTooltipFormulaRenderer} from '../../../../ForecastTooltipFormulaRenderer';

const FixedPriceOverview = ({project, currencySymbol}) => {
	const intl = useIntl();
	const {formatMessage} = intl;

	return (
		<TableSectionWrapper>
			<TableSectionTitle>
				<TableSectionTitleHeadline>
					{formatMessage({id: 'project_budget.fixed_price_budget_headline'})}
				</TableSectionTitleHeadline>
			</TableSectionTitle>
			<TableWrapper>
				<HighLevelBudgetNumbersBox>
					<ForecastTooltip
						maxWidth={400}
						content={
							<ForecastTooltipFormulaRenderer
								items={[
									{
										description: [
											formatMessage({id: 'project_budget.revenue_recognition.fixed_price_budget'}),
										],
									},
								]}
								translatedMessage={true}
							/>
						}
					>
						<HighLevelNumber
							currencySymbol={currencySymbol}
							labelTranslationId={'common.fixed_price'}
							value={project.budget}
							numberType={NUMBER_TYPE.MONEY}
							cy={'fixed-price-budget'}
						/>
					</ForecastTooltip>
				</HighLevelBudgetNumbersBox>
			</TableWrapper>
		</TableSectionWrapper>
	);
};

export default createFragmentContainer(FixedPriceOverview, {
	project: graphql`
		fragment FixedPriceOverview_project on ProjectType {
			id
			budget
		}
	`,
});
